import { useTranslator } from 'tradera/lang/translate';
import GiftIcon from 'tradera/blueprint/theme/icons-colored/gift.svg?jsx';
import ForwardIcon from 'tradera/blueprint/theme/icons2/forward.svg?jsx';
import { useAppDispatch } from 'tradera/state/hooks';
import { openReferralModal } from 'tradera/state/ui/reducer';

export const ReferralAlert = () => {
    const { t } = useTranslator();
    const dispatch = useAppDispatch();

    return (
        <div
            className="d-flex py-1 px-2 cursor-pointer border border-primary"
            onClick={() => dispatch(openReferralModal())}>
            <GiftIcon className="icon icon-xl mr-2 flex-shrink-0" />
            <div className="d-flex flex-column flex-grow-1 text-styled">
                <span className="font-weight-bold">
                    {t('siteheader_referralAlert_line1')}
                </span>
                <div className="d-flex justify-content-between align-items-center">
                    <span>{t('siteheader_referralAlert_line2')}</span>
                    <ForwardIcon className="icon icon-xs flex-shrink-0 ml-1" />
                </div>
            </div>
        </div>
    );
};
